import type { BrandSitePage } from "@/lib/brand-site-api";

/** 静态页源代码编辑：排序与路径标签（与 IDE 文件树一致）。 */
export function sortBrandSiteSourcePages(pages: readonly BrandSitePage[]): BrandSitePage[] {
  return [...pages].sort((a, b) => {
    if (a.is_home !== b.is_home) return a.is_home ? -1 : 1;
    return a.slug.localeCompare(b.slug, "zh-CN");
  });
}

export function brandSiteSourceFilePath(slug: string): string {
  return `/pages/${slug}.html`;
}

export function brandSiteSourceFileLabel(page: BrandSitePage): string {
  const title = page.title?.trim() || page.slug;
  return page.is_home ? `${title} · 首页` : title;
}

export function resolveBrandSiteSourceSlug(
  pages: readonly BrandSitePage[],
  selectedSlug: string | null,
): string | null {
  const sorted = sortBrandSiteSourcePages(pages);
  if (sorted.length === 0) return null;
  if (selectedSlug) {
    const hit = sorted.find((page) => page.slug === selectedSlug);
    if (hit) return hit.slug;
  }
  const home = sorted.find((page) => page.is_home);
  return home?.slug ?? sorted[0]?.slug ?? null;
}

export function isBrandSiteSourceDirty(saved: string, current: string): boolean {
  return saved !== current;
}
